<template>
    <b-card>
        <b-card-header>Lägg till DMT</b-card-header>
        <b-card-body>
            <b-row>
                <b-col>

                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label>Period</label><br />
                    Från:
                    <datepicker v-model="dateStart" :stepper="false" :disabled="false"></datepicker>
                    Till:
                    <datepicker v-model="dateEnd" :stepper="false" :disabled="false"></datepicker>


                </b-col>
                <b-col>
                    <label>Transportör</label><br>
                    <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-checkbox-group v-model="transporters" :options="GetTransporters()"
                            :aria-describedby="ariaDescribedby" name="flavour-2a" stacked></b-form-checkbox-group>
                    </b-form-group>
                    <!-- {{ transporters }} -->
                </b-col>
                <b-col>
                    <label>Produkt</label><br>
                    <input type="checkbox" v-model="allProducts" /> (ALLA)
                    <b-card v-if="!allProducts">
                        <b-card-body>Specifika produkter:</b-card-body>
                        <b-form-group v-slot="{ ariaDescribedby }">
                            <b-form-checkbox-group v-model="products" :options="GetProducts(transporters)"
                                :aria-describedby="ariaDescribedby" name="flavour-2a" stacked></b-form-checkbox-group>
                        </b-form-group>
                        <!-- {{ products }} -->
                    </b-card>
                </b-col>
                <b-col>
                    <label>DMT-procent:</label><br>
                    <b-form-input type="number" v-model="dmtPercentage"></b-form-input>
                    <br>
                    <b-alert v-model="errMsgs && errMsgs.length > 0" variant="danger">
                        <li v-for="(r, i) in errMsgs" :key="i">{{ r }}</li>
                    </b-alert>
                    <b-button variant="primary" @click="Save()">Lägg till</b-button>
                </b-col>
                <b-col>

                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>
<script>
import { Api } from "../../lib/api";
const api = new Api();
import datepicker from "../../components/datepicker.vue";
import moment from "moment";

const uniqueArray = (array) => Array.from(new Set(array));

export default {
    name: 'fuelchargeedit',
    components: { datepicker },
    data() {
        return {
            work: null,
            basics: null,
            transporters: [],
            products: [],
            allProducts: true,
            dateStart: null,
            dateEnd: null,
            errMsgs: [],
            dmtPercentage: null,
        }
    },
    created() {
        console.log('Fuelchargeedit');
        if (!this.basics) {
            api.get("/api/booking/getbasics").then((res) => {
                this.basics = res.data;
                this.$forceUpdate();
            });
            //this.getData();
        }
    },
    methods: {
        GetTransporters() {
            let res = [];
            if (this.basics) {
                res = this.basics.products.map(x => x.TransporterName);
                res = uniqueArray(res);
            }
            return res;
        },
        GetProducts(tsps) {
            let res = [];
            if (this.basics) {
                res = this.basics.products.filter(x => tsps.indexOf(x.TransporterName) >= 0);
                res = res.map(x => x.PrettyName);
                res = uniqueArray(res);
            }
            return res;
        },
        GetSelectedProducts() {
            let res = [];
            if (this.transporters) {
                res = this.basics.products.filter(x => this.transporters.indexOf(x.TransporterName) >= 0);
                if (!this.allProducts)
                    res = res.filter(x => this.products.indexOf(x.PrettyName) >= 0);

            }
            return res;

        },
        Validate() {
            let res = [];
            if (!moment(this.dateStart).isValid())
                res.push('Startdatum saknas eller är inkorrekt');
            if (!this.dateEnd)
                res.push('Startdatum saknas eller är inkorrekt');
            if (this.dateStart >= this.dateEnd)
                res.push('Startdatum verkar vara senare än slutdatum');

            if (this.transporters.length == 0)
                res.push('Ingen transportör är vald');
            else {
                if (this.products.length == 0 && !this.allProducts)
                    res.push('Inga produkter är valda');
            }

            if (!this.dmtPercentage)
                res.push('Dmt värdet verkar konstigt.');

            this.errMsgs = res;

            return this.errMsgs.length == 0;
        },
        Save() {
            if (this.Validate()) {
                var msg = `Vill du för perioden ${this.dateStart}-${this.dateEnd}\nsätta\nDMT=${this.dmtPercentage}%\n`;
                msg += `för följande transportörer:\n${this.transporters}\n`;
                msg += `och produkter:\n${(this.allProducts) ? 'ALLA' : this.products}?`;
                if (confirm(msg)) {
                    alert('OK!');
                    var bd = [];
                    const selProds = this.GetSelectedProducts();
                    this.transporters.map(t => {
                        let d = {
                            StartDate: this.dateStart, EndDate: this.dateEnd,
                            TransporterName: t,
                            DmtPercentage: this.dmtPercentage
                        };
                        if (this.allProducts)
                            bd.push(d);
                        else {
                            selProds.filter(x => x.TransporterName == t)
                                .map(p => {
                                    bd.push({ ...d, ProductKey: p.ProductKey });
                                });

                        }
                    });
                    api.post('/api/debit/addfuelcharges', bd).then(res => {
                        //alert(res.data);
                        this.$emit('saved', res.data);
                    }).catch(err => alert(err));

                }
            }
        }
    }
}
</script>